import React from 'react';
import { FiDroplet } from 'react-icons/fi';
import tnsLogo from '../../../assets/images/tnslogo.png';
import { CheckCircle } from 'lucide-react';

const OPTThankYou = ({ onNewTransaction }) => (
  <div className="bg-white text-gray-800 h-full flex flex-col overflow-hidden">
    {/* Header */}
    <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100 flex-shrink-0">
      <div className="flex items-center space-x-1.5">
        <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
          <FiDroplet className="w-3 h-3 text-white" />
        </div>
        <span className="font-bold text-gray-800 text-xs">Fuel Co</span>
      </div>
      <div className="flex items-center space-x-1">
        <span className="text-[10px] text-gray-400">Powered by</span>
        <img src={tnsLogo} alt="TNS" className="h-4" />
      </div>
    </div>

    {/* Content */}
    <div className="flex-1 flex flex-col items-center justify-center px-3">
      <CheckCircle className="w-10 h-10 text-green-600 mb-2" />
      <div className="text-base font-bold text-gray-800 mb-1">Thank You!</div>
      <div className="text-[10px] text-gray-600 text-center mb-3">
        Transaction complete. Please take your card.
      </div>
      <button 
        onClick={onNewTransaction}
        className="px-4 py-1.5 bg-blue-600 text-white font-bold text-xs rounded-lg hover:bg-blue-700"
      >
        NEW TRANSACTION
      </button>
    </div>
  </div>
);

export default OPTThankYou;
